import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';

export const client = new ApolloClient({
  link: createHttpLink({
    uri: process.env.BFF_URL,
    headers: { 
      'Content-Type': 'application/json', 
      'apollographql-client-name': '@dasa/npac-webplatform-front-global'
    },
  }),
  cache: new InMemoryCache(),
});